import template from './shiptype.html';
import controller from './shiptype.controller';
import './shiptype.scss';

let shiptypeComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default shiptypeComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/shiptype.component.js